import {Alert, Button, Tabs} from "antd";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";
import {StyledPageHeader, StyledPageWrapper} from "../../../styles/dashboard/calls/calls";
import {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {AccountSettings} from "../../../components/settings/account-settings";
import {ErrorBoundary} from "react-error-boundary";
import {KycPageView} from "../../../kyc/useCases/get-kyc-status/page";
import {getGoogleCalendarSettingsPath} from "../../../services/config";

const SettingPage = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("activeTab");
  const [defaultActiveKey, setDefaultActiveKey] = useState<"account" | "kyc">("account");
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab === "calendar") {
      navigate(getGoogleCalendarSettingsPath(), {replace: true});
      return;
    }
    if (activeTab === "kyc") {
      setDefaultActiveKey("kyc");
    }
  }, [activeTab, navigate]);

  useEffect(() => {
    const code = searchParams.get("code");
    if (!code) return;

    const next = new URLSearchParams();
    next.set("code", code);
    const scope = searchParams.get("scope");
    if (scope) next.set("scope", scope);

    navigate(`/google/verify?${next.toString()}`, {replace: true});
  }, [navigate, searchParams]);

  function handleTabClick(key: string) {
    if (key === "account") {
      setDefaultActiveKey("account");
      navigate("/settings?activeTab=account");
    }
    if (key === "kyc") {
      setDefaultActiveKey("kyc");
      navigate("/settings?activeTab=kyc");
    }
  }
  return (
    <DashboardWrapper pageTitle="Settings">
      <StyledPageHeader>Settings</StyledPageHeader>
      <StyledPageWrapper>
        <div className="main-area">
          <Tabs
            defaultActiveKey={defaultActiveKey}
            activeKey={defaultActiveKey}
            onTabClick={(key) => handleTabClick(key)}
          >
            <Tabs.TabPane tab="Account & security" key="account">
              <ErrorBoundary
                FallbackComponent={({error, resetErrorBoundary}) => (
                  <div style={{marginTop: "1.8rem"}}>
                    <Alert
                      message="Sorry, something went wrong."
                      showIcon
                      description={error.message}
                      type="error"
                      action={
                        <Button
                          onClick={() => {
                            resetErrorBoundary();
                          }}
                          size="small"
                          danger
                        >
                          Reset
                        </Button>
                      }
                    />
                  </div>
                )}
              >
                <AccountSettings />
              </ErrorBoundary>
            </Tabs.TabPane>
            <Tabs.TabPane tab="KYC verification" key="kyc">
              <ErrorBoundary
                FallbackComponent={({error, resetErrorBoundary}) => (
                  <div style={{marginTop: "1.8rem"}}>
                    <Alert
                      message="Sorry, something went wrong."
                      showIcon
                      description={error.message}
                      type="error"
                      action={
                        <Button
                          onClick={() => {
                            resetErrorBoundary();
                          }}
                          size="small"
                          danger
                        >
                          Reset
                        </Button>
                      }
                    />
                  </div>
                )}
              >
                <KycPageView />
              </ErrorBoundary>
            </Tabs.TabPane>
          </Tabs>
        </div>
        <div className="widget-area"></div>
      </StyledPageWrapper>
    </DashboardWrapper>
  );
};

export {SettingPage};
